// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseStateSprite from "../../../../../engines/components/state/BaseStateSprite";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";
import { LotteryKind } from "../common/data/LotteryKind";
import LotteryItemBase from "../common/LotteryItemBase";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MahjongItemBase extends LotteryItemBase {

	@property({ type: BaseStateSprite, displayName:'' })
	sprBg: BaseStateSprite = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprContent: cc.Sprite = null;
   
    private cardData: number = null;
    // onLoad () {}

    start () {
        this.initUI();
    }

    setData(
        cardData: number
    ) {
        this.cardData = cardData;
    }

    initUI() {
        this.sprContent.node.active = false;
        let path = "res/mahjong/mj/" + this.cardData;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.lotteryBundle).load(path, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.sprContent.node.active = true;
                    this.sprContent.spriteFrame = imgs;
                }
            }
        );
    }

    showBgState(bfill: boolean) {
        this.sprBg.setFill(bfill);
    }

    // update (dt) {}
}
